import { createFileRoute } from "@tanstack/react-router"

import { IllustratedState } from "../../../components/IllustratedState"
import { Architect } from "./-Architect"
import { ErrorState } from "./-Error"

const RouteComponent = () => {
  return (
    <IllustratedState
      title="The insights fox is still at the drawing board"
      description="Blueprints are pinned up and the first charts are being drafted. Insights opens once the plans are signed off."
    >
      <Architect />
    </IllustratedState>
  )
}

export const Route = createFileRoute("/_chrome/insights/")({
  component: RouteComponent,
  errorComponent: ErrorState,
})
